export const ADMIN_USERS_MANAGEMENT_ACTION = 'admin/users/management';
export const GET_ADMIN_USER_BY_ID_ACTION = 'admin/get/user';
export const ADMIN_CREATE_USER_ACTION = 'admin/create/user';